import { OverlayTrigger, Tooltip } from "react-bootstrap";
import moment from "moment-timezone";
import getSymbolFromCurrency from "currency-symbol-map";
import { toAbsoluteUrl } from "../../../_helpers";
import CertificateLink from "../../CertificateLink";
import DiamondTypeTag from "../../Popup/DiamondTypeTag";

function numberWithCommas(x) {
    return x.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const shadeMappings = {
    none: { label: "No.SH", tooltip: "Shade: NONE" },
    brown: { label: "BR", tooltip: "Shade: Brown" },
    "light brown": { label: "L.BR", tooltip: "Shade: Light Brown" },
    green: { label: "GR", tooltip: "Shade: Green" },
    "light green": { label: "L.GR", tooltip: "Shade: Light Green" },
    grey: { label: "GREY", tooltip: "Shade: Grey" },
    black: { label: "BLK", tooltip: "Shade: Black" },
    pink: { label: "PINK", tooltip: "Shade: Pink" },
    blue: { label: "BLUE", tooltip: "Shade: Blue" },
    "mix tinge": { label: "MIX", tooltip: "Shade: Mix Tinge" },
};

const renderShadeLabel = (shade) => {
    const mapping = shadeMappings[shade ? shade.toLowerCase() : ""];
    if (!mapping) return null;

    return (
        <span>
            <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="tooltip">{mapping.tooltip}</Tooltip>}
            >
                <span
                    className={`label label-light-primary label-light-shade_${shade
                        .toLowerCase()
                        .replace(
                            " ",
                            "_"
                        )} label-pill label-inline label-sm mr-1 font-weight-bold px-2`}
                >
                    {mapping.label}
                </span>
            </OverlayTrigger>
        </span>
    );
};

export const OrderHistoryColumns = (language, userinfo, data) => {
    const columns = [
        {
            Header: language.CONFIRM_DIAMOND_ORDERNO,
            className: "align-middle text-center",
            accessor: (d) => {
                return (
                    <>
                        <div
                            className="text-break d-inline-block"
                            style={{ maxWidth: "150px", minWidth: "150px" }}
                        >
                            {d.conformGoodId || ""}
                        </div>
                        <p className="m-0 small text-muted">
                            {d.created_date
                                ? moment
                                      .tz(
                                          d.created_date,
                                          userinfo.timezone
                                              ? userinfo.timezone
                                              : Intl.DateTimeFormat().resolvedOptions()
                                                    .timeZone
                                      )
                                      .format("YYYY-MM-DD HH:mm:ss")
                                : "-"}
                        </p>
                    </>
                );
            },
        },
        {
            Header: language.CONFIRM_DIAMOND_DIAMONDDETAILS,
            accessor: (d) => (
                <>
                {d.diamondType === "PN" || d.diamondType === "PL" ? 
                    <div className="row">
                        <div className="col-2 text-center p-0">
                            <img
                                className="img-fluid mr-2"
                                alt={d.shape}
                                src={toAbsoluteUrl(`/media/shape/svg_shape/parcel/${d.shape.toLowerCase()}.svg`)}
                                width="50px"
                                onError={e => {
                                    e.currentTarget.src = toAbsoluteUrl(
                                        `/media/shape/svg_shape/parcel/other.svg`
                                        )
                                    }}
                            />
                        </div>
                        <div className="col-10 pl-2 p-0 text-left">
                            <div className={`mb-1 ${d.diamondType === "PN" ? "natTab" : "labTab"}`}>
                                <DiamondTypeTag diamondTypeTagColor={d.diamondTypeTagColor} diamondTypeTag={d.diamondTypeTag}/>
                                <span className={`cursor-pointer small ml-2`}>
                                    {d.diamondType}-{d.stockID}
                                </span>
                                <span className={`text-capitalize small ml-2`}>
                                    By: {d.parcelType === "carat" ? "Cts." : "Pcs."}
                                </span>
                                <span className={`text-capitalize small ml-2`}>
                                {d.parcelLength ? d.parcelLength.toFixed(2):"" }-{d.parcelWidth?d.parcelWidth.toFixed(2):"" } MM
                                </span>
                            </div>
    
                            <span className="text-dark font-weight-bold d-block">
                                {d.shape}{" "}
                                {d.weight ? d.weight.toFixed(2):""}Ct.{" "}
                                {d.parcelPieces}Pcs.{" "}
                                {d.color}{" "}
                                {d.clarity}{" "}
                            </span>
                        </div>
                    </div>
                 :
                    <div className="row">
                        <div className="col-2 text-center p-0">
                            {d.image? (
                                <img
                                    className="img-fluid mr-2"
                                    alt={d.shape}
                                    src={d.image}
                                    width="50px"
                                    onError={e => {
                                        e.currentTarget.src = toAbsoluteUrl(
                                            `/media/shape/${d.shape ? d.shape.toLowerCase() : ""}-no.png`
                                            )
                                        }}
                                />
                            ) : (
                                <img
                                    className="img-fluid mr-2"
                                    alt={d.shape}
                                    src={toAbsoluteUrl(
                                        `/media/shape/${d.shape ? d.shape.toLowerCase() : ""}-no.png`
                                    )}
                                    onError={e => {
                                        e.currentTarget.src = toAbsoluteUrl(
                                            `/media/shape/noimage.jpg`
                                        )
                                    }}
                                    width="50px"
                                    style={{ backgroundColor: "#f4f4f4" }}
                                />
                            )}
                        </div>
                        <div className="col-10 pl-2 p-0 text-left">
                            <div className={`mb-1 ${d.diamondType === "N" ? "natTab" : "labTab"}`}>
                                <DiamondTypeTag diamondTypeTagColor={d.diamondTypeTagColor} diamondTypeTag={d.diamondTypeTag}/>
                                <a href={`/details/confirm-${d.conformGoodId}`} target="_blank" rel="noreferrer" className={`cursor-pointer small ml-2`} >
                                    {d.diamondType === "N" || d.diamondType === "W" ? "N" : "L"}-{d.stockID}
                                </a>
                                
                                <CertificateLink Certificate_link={d.certificate_link} lab={d.lab} certificate={d.certificate} className={`mx-2 small`} />
                            </div>
    
                            <span className="text-dark font-weight-bold d-block">
                                {d.shape}{" "}
                                {d.weight}{" "}
                                {d.color}{" "}
                                {d.clarity}{" "}{d.cut}{" "}{d.polish}{" "}{d.symmetry}{" "}
                                {d.fluorescence}
                            </span>
                        </div>
                    </div> 
                    }
                </>
            ),
            className: "text-center align-middle",
            disableSortBy: true,
        },
        {
            Header: language.CONFIRM_DIAMOND_STATUS,
            accessor: (d) => (
                <div>
                    <div
                        className={`label ${
                            d.diamondStatus === "Order Approve"
                                ? "label-primary"
                                : d.diamondStatus === "Pending"
                                ? "label-warning"
                                : d.diamondStatus === "Ready For Invoice"
                                ? "label-success"
                                : d.diamondStatus === "Ready to Ship"
                                ? "label-success"
                                : d.diamondStatus === "Rejected"
                                ? "label-danger"
                                : d.diamondStatus === "QC Rejected"
                                ? "label-danger"
                                : d.diamondStatus === "QC Review"
                                ? "label-warning"
                                : d.diamondStatus === "QC Approved"
                                ? "label-success"
                                : ""
                        } label-inline text-nowrap  mr-2`}
                    >
                        {d.diamondStatus}
                    </div>
                </div>
            ),
            className: "text-center align-middle",
        }
    ];

      if (data?.[0]?.customerheadername) {
            columns.push({
                id: "Purchase Price",
                Header: <span>{data?.[0]?.customerheadername || "Purchase Price"}</span>,
                accessor: (d) => (
                    <>
                        <span className="font-weight-bold">
                            {d.ourPriceSymbol}{numberWithCommas(parseFloat(d["ourPrice"]))}
                        </span>{" "}
                        <br />
                        <span className="text-muted small">
                            {d.ourPriceSymbol}/CT {numberWithCommas(parseFloat(d["ourRate"]))}
                        </span>
                    </>
                ),
                className: "text-right pr-12 align-middle",
            })
        }
        if (data?.[0]?.customerexchangeheadername) {
            columns.push({
                Header: <span>{data?.[0]?.customerexchangeheadername || "Exchange Price"}</span>,
                id: "ourpriceothercurr",
                accessor: (d) => (
                    <>
                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id="tooltip"> Ex. Rate : {d.ourPriceCustomerSymbolName} {d.ourPriceCustomerSymbol}{d.customerCurrencyRate}</Tooltip>}
                        >
                            <div>
                                <span className="font-weight-bold">
                                    {d.ourPriceCustomerSymbol}{numberWithCommas(parseFloat(d["ourPriceCustomer"]))}
                                </span>{" "}
                                <br />
                                <span className="text-muted small">
                                    {d.ourPriceCustomerSymbol}/CT {numberWithCommas(parseFloat(d["ourRateCustomer"]))}
                                </span>
                            </div>
                        </OverlayTrigger>
    
                    </>
                ),
                className: "text-right pr-12 align-middle",
            });
        }
        columns.push({
            Header: language.CONFIRM_DIAMOND_LOCATIONANDDELIVERY,
            accessor: (d) => (
                <>
                    {d.country}
                    <br />
                    <span className="text-muted small">
                        {d.shippingDays} days
                    </span>
                </>
            ),
            className: "text-center align-middle",
            disableSortBy: true,
        })

    return columns;
};
